/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Container,
  Divider,
  Grid,
  SvgIcon,
  Typography,
} from "@material-ui/core";
import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import globalColors from "../../../../../_metronic/_assets/sass/custom/globalColors.scss";
import { ReactComponent as checkedDot } from "../../../../assets/icons/checkedDot.svg";
import { ReactComponent as lawsuit } from "../../../../assets/icons/lawsuit.svg";
import { ReactComponent as unCheckedDot } from "../../../../assets/icons/unCheckedDot.svg";
import InputForm from "../../../../components/InputForm";
import { LabelWithBackLine } from "../../../../components/LabelWithBackLine";
import { lawsuitStatus as optionsStatus } from "../../../../enum/LawsuitStatus";
import { LawsuitStatusEnum } from "../../../../enum/LawsuitStatusEnum";
import { USER_ROLES } from "../../../../enum/UserRoles";
import { AppAPIService } from "../../../../services/AppAPIService";
import store from "../../../../store/store";
import formatDocument from "../../../../utils/FormatDocument";
import { FormatMoney } from "../../../../utils/FormatMoney";
import FormatNumberLawsuit from "../../../../utils/FormatNumberLawsuit";
import verifyCpfCnpj from "../../../../utils/validators/IsValidCpfCnpj";
import Loading from "../../../home/components/Loading";
import FormActions from "../../components/FormActions";
import { UserDocumentsDataTable } from "../Lawsuit/components/UserDocumentsDataTable";
import DocumentCategoryModal from "./components/DocumentCategory/DocumentCategoryModal";
import { LawsuitDocumentTable } from "./components/LawsuitDocumentDataTable/LawsuitDocumentTable";
import { LogsView } from "./components/LogsTable";
import useFetchData from "./components/LogsTable/helpers/fetchLogs";
import { PublicationsTable } from "./components/PublicationsDataTable/PublicationTable";
import { PublicationModal } from "./components/PublicationsDataTable/components/PublicationModal";
import { Button } from "./styles.css";
import styles from "./styles.module.scss";
import { useSelector } from "react-redux";
import { isAfter, isBefore, parseISO } from "date-fns";
import { isEqual } from "date-fns";

const LawsuitFormEdit = () => {
  const { id } = useParams();

  const document = useSelector((state) => state.document);

  let api = AppAPIService.getInstance();
  const { auth } = store.getState();
  const [user, setuser] = useState(null);

  const [loading, setLoading] = useState(false);

  const [actionId, setActionId] = useState("");
  const [lawsuitStatus, setLawsuitStatus] = useState();
  const [lawsuitStatusError, setLawsuitStatusError] = useState("");
  const [lawsuitStatusRole, setLawsuitStatusRole] = useState("");
  const [openAddDocumentCategory, setOpenAddDocumentCategory] = useState(false);

  const [statusHistory, setStatusHistory] = useState("");

  const [reload, setReload] = useState(false);

  /* companyName */
  const [companyName, setCompanyName] = useState("");
  const [companyNameRole, setCompanyNameRole] = useState("ok");
  const [companyNameError, setCompanyNameError] = useState("");
  const [page, setPage] = useState(1);

  const {
    data: item,
    isLoading,
    isFetched,
    error,
    refetch,
  } = useFetchData({
    queryParams: {
      page,
      take: 10,
      order: "DESC",
      lawsuitId: id,
    },
  });

  const handlePageChange = (event, value) => {
    refetch();
    setPage(value);
  };

  const handleInputCompanyName = (companyName) => {
    if (!companyName) {
      setCompanyName();
      setCompanyNameError("Campo obrigatório");
      setCompanyNameRole("notOk");
    } else {
      setCompanyName(companyName);
      setCompanyNameError("");
      setCompanyNameRole("ok");
    }
  };
  /* end companyName*/

  /* typePerson */
  const [typePerson, setTypePerson] = useState("");
  const [typePersonRole, setTypePersonRole] = useState("");
  const [typePersonError, setTypePersonError] = useState("");
  const handleInputTypePerson = (e) => {
    if (!e) {
      setTypePerson();
      setTypePersonError("");
      setTypePersonRole("ok");
    } else {
      setTypePerson(e);
      setTypePersonError("");
      setTypePersonRole("ok");
    }
  };
  /* end typePerson*/

  /*cpfCnpj*/
  const [cpfCnpj, setCpfCnpj] = useState("");
  const [cpfCnpjRole, setCpfCnpjRole] = useState("ok");
  const [cpfCnpjError, setCpfCnpjError] = useState("");
  const handleInputCpfCnpj = useCallback((e) => {
    e = e.replace(/\D/g, "");
    if (e.length > 14) {
      return;
    } else if (!verifyCpfCnpj(e)?.isValid) {
      setCpfCnpjError("Não é um CPF/CNPJ válido.");
      setCpfCnpjRole("notOk");
      setCpfCnpj(formatDocument(e));
    } else {
      setCpfCnpj(formatDocument(e));
      setCpfCnpjError("");
      setCpfCnpjRole("ok");
    }
  }, []);
  /* end cpfCnpj*/

  /* adverseParty */
  const [adverseParty, setAdverseParty] = useState("");
  const [adversePartyRole, setAdversePartyRole] = useState("");
  const [adversePartyError, setAdversePartyError] = useState("");
  const handleInputAdverseParty = (e) => {
    if (!e) {
      setAdverseParty();
      setAdversePartyError("");
      setAdversePartyRole("ok");
    } else {
      setAdverseParty(e);
      setAdversePartyError("");
      setAdversePartyRole("ok");
    }
  };
  /* end adverseParty*/

  /* courtCaseNumber */
  const [courtCaseNumber, setCourtCaseNumber] = useState("");
  const [courtCaseNumberRole, setCourtCaseNumberRole] = useState("");
  const [courtCaseNumberError, setCourtCaseNumberError] = useState("");
  const handleInputCourtCaseNumber = (e) => {
    if (e.length > 25) {
      return;
    } else if (!e) {
      setCourtCaseNumber();
      setCourtCaseNumberError("");
      setCourtCaseNumberRole("ok");
    } else {
      setCourtCaseNumber(FormatNumberLawsuit(e));
      setCourtCaseNumberError("");
      setCourtCaseNumberRole("ok");
    }
  };
  /* end courtCaseNumber*/

  /* action */
  const [action, setAction] = useState();
  const [actionRole, setActionRole] = useState("");
  const [actionError, setActionError] = useState("");
  const [actionsList, setActionsList] = useState([]);
  const handleInputAction = (e) => {
    if (!e) {
      setAction();
      setActionError("Campo obrigatório");
      setActionRole("notOk");
    } else {
      setAction(e);
      setActionError("");
      setActionRole("ok");
    }
  };
  /* end action*/

  /* value */
  const overLimitInput = (e, limit) => {
    if (e.length > limit) {
      return true;
    }
    return false;
  };

  const [value, setValue] = useState("");
  const [valueRole, setValueRole] = useState("");
  const [valueError, setValueError] = useState("");
  const handleInputValue = (e) => {
    if (!e) {
      setValue();
      setValueError("");
      setValueRole("ok");
    } else {
      if (overLimitInput(e, 20)) return;

      setValue(FormatMoney(e));
      setValueError("");
      setValueRole("ok");
    }
  };
  /* end value*/

  /* distributionDate */
  const [distributionDate, setDistributionDate] = useState("");
  const [distributionDateRole, setDistributionDateRole] = useState("");
  const [distributionDateError, setDistributionDateError] = useState("");
  const handleInputDistributionDate = (e) => {
    if (!e) {
      setDistributionDate();
      setDistributionDateError("");
      setDistributionDateRole("ok");
    } else {
      setDistributionDate(e);
      setDistributionDateError("");
      setDistributionDateRole("ok");
    }
  };
  /* end distributionDate*/

  /* limitDate */
  const [limitDate, setLimitDate] = useState("");
  const [limitDateRole, setLimitDateRole] = useState("");
  const [limitDateError, setLimitDateError] = useState("");
  const handleInputLimitDate = (e) => {
    if (!e) {
      setLimitDate();
      setLimitDateError("");
      setLimitDateRole("ok");
    } else {
      setLimitDate(e);
      setLimitDateError("");
      setLimitDateRole("ok");
    }
  };
  /* end limitDate*/

  /* billingAlert */
  const [billingAlert, setBillingAlert] = useState("");
  const [billingAlertRole, setBillingAlertRole] = useState("");
  const [billingAlertError, setBillingAlertError] = useState("");
  const handleInputBillingAlert = (e) => {
    if (!e) {
      setBillingAlert();
      setBillingAlertError("");
      setBillingAlertRole("ok");
    } else {
      setBillingAlert(e);
      setBillingAlertError("");
      setBillingAlertRole("ok");
    }
  };
  /* end billingAlert*/

  /* status */
  const [status, setStatus] = useState("");
  const [statusRole, setStatusRole] = useState("");
  const [statusError, setStatusError] = useState("");
  const handleInputLawsuitStatus = (e) => {
    let find = optionsStatus.find((item) => item.value === e);
    if (!find) {
      setStatusError("Campo obrigatório");
      setStatusRole("notOk");
    } else {
      setLawsuitStatus(find);
      setStatus(find.value);
      setStatusError("");
      setStatusRole("ok");
    }
  };
  /* end status*/

  /* form validation */
  const formIsValid = useCallback(() => {
    let validForm = true;

    validForm =
      adverseParty !== "" &&
      adversePartyRole === "ok" &&
      limitDate !== "" &&
      limitDateRole === "ok";

    return validForm;
  }, [adverseParty, adversePartyRole, limitDate, limitDateRole]);

  /* end form validation */
  /* submit */
  const submit = async (e) => {
    setLoading(true);
    e.preventDefault();

    const replaceValue =
      value &&
      value.replace("R$", "").replace(".", "").replace(",", ".").trim();

    try {
      setLoading(true);
      await api.makeHttpRequest({
        url: `/lawsuit/${id}`,
        method: "PUT",
        data: {
          adverseParty,
          courtCaseNumber: courtCaseNumber ?? "",
          actionId: action.value,
          value: replaceValue ?? "",
          distributionDate: moment(distributionDate).utc().format(),
          limitDate: moment(limitDate)
            .set("h", 3)
            .utc()
            .format("YYYY-MM-DD HH:mm:ss"),
          billingAlert: parseInt(billingAlert),
          status: lawsuitStatus.value,
        },
      });
      setLoading(false);
      Swal.fire({
        icon: "success",
        title: "Sucesso!",
        text: "Processo atualizado com sucesso.",
      });
      setReload(!reload);
    } catch (error) {
      setLoading(false);
      console.log(error.response);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Erro ao atualizar o processo.",
      });
    } finally {
      setLoading(false);
    }
  };
  /* end submit */

  useEffect(() => {
    api
      .makeHttpRequest({
        url: `/action/list-paginated`,
      })
      .then((response) => {
        const actions = response.data.map((resp) => ({
          value: resp.id,
          label: resp.action,
        }));

        setActionsList(actions);
      });
    setReload(false);
  }, [reload, actionId, api]);

  /* clean form */
  const onCleanForm = async () => {
    setCompanyName("");
    setCpfCnpj("");
    setCompanyName("");
    setAdverseParty("");
    setCourtCaseNumber("");
    setValue("");
    setDistributionDate("");
  };
  /* end clean form */

  const [staticCourtCaseNumber, setStaticCourtCaseNumber] = useState("");
  const [staticAction, setStaticAction] = useState("");

  const [lawsuits, setLawsuit] = useState();

  const fetchLawsuitInfo = useCallback(async () => {
    setLoading(true);
    await onCleanForm();
    try {
      const response = await api.makeHttpRequest({
        url: `/lawsuit/get-by-id/${id}`,
        method: "GET",
      });
      // console.log(response, "HERE");
      setLoading(false);
      handleInputCompanyName(response?.companyName);
      handleInputAdverseParty(response?.adverseParty);
      handleInputCourtCaseNumber(response?.courtCaseNumber);
      setStaticCourtCaseNumber(response?.courtCaseNumber);
      handleInputAction({
        value: response?.action?.id,
        label: `${response?.action?.action}`,
      });
      setStaticAction(response?.action?.action);
      setActionId(response?.action);
      handleInputValue(response?.value);
      setLawsuit(response);
      if (response.distributionDate)
        handleInputDistributionDate(
          moment.utc(response?.distributionDate).format("YYYY-MM-DD")
        );
      setuser(response?.user);
      setStatusHistory(response?.statusHistory);
      handleInputLawsuitStatus(response?.status);
      handleInputTypePerson(response?.type_person);
      handleInputCpfCnpj(response?.user?.cpfCnpj ?? "");
      handleInputBillingAlert(response?.billingAlert ?? "");

      if (response?.user?.cpfCnpj)
        handleInputTypePerson(
          response?.user?.cpfCnpj > 14 ? "Pessoa Jurídica" : "Pessoa Física"
        );
      if (response.limitDate)
        handleInputLimitDate(
          moment.utc(response?.limitDate).format("YYYY-MM-DD")
        );
    } catch (error) {
      console.log(error);
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Erro ao buscar o processo.",
      });
    }
  }, [api]);
  // const getHistory = () => {
  //   api.makeHttpRequest({
  //     url: `/lawsuit/${id}/history/client/${user?.id}`,
  //     method: "GET",
  //   });
  // };
  // useEffect(() => {
  //   getHistory();
  // }, [user, reload, api, document]);

  useEffect(() => {
    fetchLawsuitInfo();
    refetch();
  }, [fetchLawsuitInfo, id, reload, api]);

  const handleSendDocumentEmail = async () => {
    try {
      setLoading(true);

      const replaceValue =
        value &&
        value.replace("R$", "").replace(".", "").replace(",", ".").trim();
      await api.makeHttpRequest({
        url: `/lawsuit/${id}`,
        method: "PUT",
        data: {
          adverseParty,
          courtCaseNumber,
          actionId: action.value,
          value: replaceValue ?? "",
          distributionDate: moment(distributionDate).utc().format(),
          limitDate: moment(limitDate)
            .set("h", 3)
            .utc()
            .format("YYYY-MM-DD HH:mm:ss"),
          billingAlert: parseInt(billingAlert),
          status: lawsuitStatus.value,
        },
      });
      const limitDateObj = parseISO(limitDate);
      const currentDate = new Date();

      limitDateObj.setHours(0, 0, 0, 0);
      currentDate.setHours(0, 0, 0, 0);

      console.log("Limit Date:", limitDateObj);
      console.log("Current Date:", currentDate);
      console.log("Limit Date (ISO):", limitDateObj.toISOString());
      console.log("Current Date (ISO):", currentDate.toISOString());

      if (isBefore(limitDateObj, currentDate)) {
        Swal.fire({
          icon: "error",
          title: "Data Limite Expirada",
          text: "Não foi possível enviar o e-mail porque a data limite já passou. Por favor, altere a data limite e tente novamente.",
        });
        setLoading(false);
        return;
      }
      await api.makeHttpRequest({
        url: `document/billing-email`,
        method: "GET",
        params: {
          lawsuitId: id,
        },
      });
      setLoading(false);
      Swal.fire({
        icon: "success",
        title: "Sucesso!",
        text: "E-mail enviado com sucesso.",
      });
      refetch();
    } catch (error) {
      setLoading(false);
      console.log(error.response);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Erro ao enviar e-mail.",
      });
    } finally {
      setLoading(false);
      refetch();
    }
  };

  useEffect(() => {
    if (document) {
      fetchLawsuitInfo();
      refetch();
      // getHistory();
    }
  }, [document]);

  const [hasPublication, setHasPublication] = useState(false);
  const [openPublicationModal, setOpenPublicationModal] = useState(false);
  const [publication, setPublication] = useState();
  const togglePublicationModal = () => {
    setOpenPublicationModal(!openPublicationModal);
  };

  return (
    <div className={styles.container}>
      <Loading isLoading={loading || isLoading} />
      <Container
        maxWidth="xl"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "start",
          width: "100%",
          marginRight: "20px",
          padding: 0,
          color: globalColors.backgroundColor2,
          backgroundColor: `${globalColors.backgroundColor4}`,
          borderRadius: "4px",
        }}
      >
        <PublicationModal
          open={openPublicationModal}
          handleClose={togglePublicationModal}
          publication={publication}
        />
        {(auth.user.role == USER_ROLES.ADMIN ||
          auth.user.role == USER_ROLES.COLLABORATOR) && (
          <DocumentCategoryModal
            open={openAddDocumentCategory}
            handleOpen={setOpenAddDocumentCategory}
            lawsuitId={id}
            setReload={setReload}
            reload={reload}
            lawsuitDocuments={lawsuits?.documents}
          />
        )}
        <Container
          maxWidth="xl"
          style={{
            width: "100%",
            margin: 0,
            padding: 0,
            display: "flex",
            alignItems: "center",
            height: "48px",
            marginTop: "2px",
          }}
        >
          <SvgIcon
            component={lawsuit}
            stroke={globalColors.primaryColor4}
            style={{
              fontSize: "24px",
              marginRight: "12px",
              marginLeft: "20px",
              fill: "none",
              fontWheight: "600",
            }}
          />
          <Typography
            variant="p"
            style={{
              fontSize: "18px",
              fontWeight: "600",
              fontFamily: "Open Sans",
              fontStyle: "normal",
            }}
          >
            Editar Processo
          </Typography>
        </Container>
      </Container>

      <Container
        className="xv-themed-surface xv-lawsuit-summary-surface"
        maxWidth="xl"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "start",
          width: "100%",
          color: globalColors.backgroundColor2,
          backgroundColor: globalColors.colorWhite,
          borderRadius: "4px",
          marginTop: "24px",
          padding: "24px 0",
        }}
      >
        <Grid
          container
          spacing={1}
          style={{
            width: "100%",
            justifyContent: "space-between",
            padding: "0 133px",
          }}
        >
          <Grid item style={{ textAlign: "center" }}>
            <Typography
              style={{
                color: globalColors.backgroundColor2,
                fontSize: "14px",
                fontWeight: "400",
              }}
            >
              Número dos Autos
            </Typography>
            <Typography
              style={{
                color: `${globalColors.primaryColor1}`,
                fontSize: "20px",
                fontWeight: "700",
                lineHeight: "24px",
                marginTop: "11px",
              }}
            >
              {staticCourtCaseNumber}
            </Typography>
          </Grid>
          <Grid item style={{ textAlign: "center", flexGrow: 4 }}>
            <Typography
              style={{
                color: globalColors.backgroundColor2,
                fontSize: "14px",
                fontWeight: "400",
              }}
            >
              Ação
            </Typography>
            <Typography
              style={{
                color: globalColors.primaryColor1,
                fontSize: "20px",
                fontWeight: "700",
                lineHeight: "24px",
                marginTop: "11px",
              }}
            >
              {staticAction}
            </Typography>
          </Grid>
          <Grid item style={{ textAlign: "center", flexGrow: 2 }}>
            <Typography
              style={{
                color: globalColors.backgroundColor2,
                fontSize: "14px",
                fontWeight: "400",
              }}
            >
              Valor do Processo
            </Typography>
            <Typography
              style={{
                color: `${globalColors.primaryColor1}`,
                fontSize: "20px",
                fontWeight: "700",
                lineHeight: "24px",
                marginTop: "11px",
              }}
            >
              {value &&
                value.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          style={{
            width: "100%",
            justifyContent: "space-between",
            marginTop: "32px",
            padding: "0 67px",
            paddingBottom: "68px",
          }}
        >
          <Grid
            item
            style={{ display: "flex", alignItems: "center", flex: "auto" }}
          >
            <Box flexGrow={1} boxShadow="none">
              <div
                style={{
                  whiteSpace: "nowrap",
                  fontSize: "18px",
                  display: "flex",
                  flexWrap: "nowrap",
                  position: "relative",
                }}
              >
                <SvgIcon component={checkedDot} />
                <div
                  style={{
                    position: "absolute",
                    top: "28px",
                    left: "-20px",
                    textAlign: "center",
                  }}
                >
                  <div style={{ fontSize: "12px", fontWeight: 700 }}>
                    Criado
                  </div>
                  {statusHistory?.createdAt && (
                    <div style={{ fontSize: "12px", fontWeight: 400 }}>
                      {moment(statusHistory?.createdAt).format("DD/MM/YYYY")}
                    </div>
                  )}
                </div>
              </div>
            </Box>
            <Divider
              style={{
                marginBottom: "2px",
                color: "red",
                backgroundColor: `${globalColors.primaryColor1}`,
                height: "0.5px",
                width: "100%",
              }}
              elevation={0}
            />
          </Grid>
          <Grid
            item
            style={{ display: "flex", alignItems: "center", flex: "auto" }}
          >
            <Box flexGrow={1} boxShadow="none">
              <div
                style={{
                  whiteSpace: "nowrap",
                  fontSize: "18px",
                  display: "flex",
                  flexWrap: "nowrap",
                  position: "relative",
                }}
              >
                <SvgIcon
                  component={
                    statusHistory?.waitingDocuments ? checkedDot : unCheckedDot
                  }
                />
                <div
                  style={{
                    position: "absolute",
                    top: "28px",
                    left: "-60px",
                    textAlign: "center",
                  }}
                >
                  <div style={{ fontSize: "12px", fontWeight: 700 }}>
                    Aguardando documento
                  </div>
                  {statusHistory?.waitingDocuments && (
                    <div style={{ fontSize: "12px", fontWeight: 400 }}>
                      {moment(statusHistory?.waitingDocuments).format(
                        "DD/MM/YYYY"
                      )}
                    </div>
                  )}
                </div>
              </div>
            </Box>
            <Divider
              style={{
                marginBottom: "2px",
                color: "red",
                backgroundColor: `${globalColors.primaryColor1}`,
                height: "0.5px",
                width: "100%",
              }}
              elevation={0}
            />
          </Grid>
          <Grid
            item
            style={{ display: "flex", alignItems: "center", flex: "auto" }}
          >
            <Box flexGrow={1} boxShadow="none">
              <div
                style={{
                  whiteSpace: "nowrap",
                  fontSize: "18px",
                  display: "flex",
                  flexWrap: "nowrap",
                  position: "relative",
                }}
              >
                <SvgIcon
                  component={
                    statusHistory?.waitingValidation ? checkedDot : unCheckedDot
                  }
                />
                <div
                  style={{
                    position: "absolute",
                    top: "28px",
                    left: "-60px",
                    textAlign: "center",
                  }}
                >
                  <div style={{ fontSize: "12px", fontWeight: 700 }}>
                    Aguardando validação
                  </div>
                  {statusHistory?.waitingValidation && (
                    <div style={{ fontSize: "12px", fontWeight: 400 }}>
                      {moment(statusHistory?.waitingValidation).format(
                        "DD/MM/YYYY"
                      )}
                    </div>
                  )}
                </div>
              </div>
            </Box>
            <Divider
              style={{
                marginBottom: "2px",
                color: "red",
                backgroundColor: `${globalColors.primaryColor1}`,
                height: "0.5px",
                width: "100%",
              }}
              elevation={0}
            />
          </Grid>
          <Grid
            item
            style={{
              display: "flex",
              alignItems: "center",
              flex: "auto",
              textAlign: "right",
              flexGrow: 0,
            }}
          >
            <Box flexGrow={1} boxShadow="none">
              <div
                style={{
                  whiteSpace: "nowrap",
                  fontSize: "18px",
                  display: "flex",
                  flexWrap: "nowrap",
                  position: "relative",
                }}
              >
                <SvgIcon
                  component={
                    statusHistory?.concluded ? checkedDot : unCheckedDot
                  }
                />
                <div
                  style={{
                    position: "absolute",
                    top: "28px",
                    left: "-25px",
                    textAlign: "center",
                  }}
                >
                  <div style={{ fontSize: "12px", fontWeight: 700 }}>
                    Concluído
                  </div>
                  <div style={{ fontSize: "12px", fontWeight: 400 }}>
                    {status >= LawsuitStatusEnum.CONCLUDED}
                  </div>
                  {statusHistory?.concluded && (
                    <div style={{ fontSize: "12px", fontWeight: 400 }}>
                      {moment(statusHistory?.concluded).format("DD/MM/YYYY")}
                    </div>
                  )}
                </div>
              </div>
            </Box>
          </Grid>
        </Grid>
      </Container>

      <form
        className={`${styles.form} xv-themed-surface`}
        style={{
          marginTop: "24px",
        }}
        autoComplete="off"
      >
        <div className={styles.containerInputs}>
          <Grid
            container
            spacing={1}
            style={{ width: "100%", margin: 0, padding: 0 }}
          >
            <Grid item xl={3} lg={3} md={3} sm={3}>
              <InputForm
                type="text"
                name="cpf"
                placeholder="Digite o CPF/CNPJ"
                label={"CPF/CNPJ *"}
                value={cpfCnpj}
                error={cpfCnpjError}
                onChange={handleInputCpfCnpj}
                role={cpfCnpjRole}
                isDisabled
              />
            </Grid>
            <Grid item xl={3} lg={3} md={3} sm={3}>
              <InputForm
                type="text"
                name="type_person"
                placeholder="Digite o tipo de pessoa"
                label={"Tipo de Pessoa"}
                value={
                  cpfCnpj.replace(/\D/g, "").length <= 11
                    ? "Pessoa Física"
                    : "Pessoa Jurídica"
                }
                error={typePersonError}
                onChange={handleInputTypePerson}
                role={typePersonRole}
                isDisabled
              />
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={6}>
              <InputForm
                type="text"
                name="companyName"
                placeholder="Digite o nome da empresa"
                label={"Razão Social/Nome *"}
                value={companyName}
                error={companyNameError}
                onChange={handleInputCompanyName}
                role={companyNameRole}
                isDisabled
              />
            </Grid>
          </Grid>
        </div>
        <div className={styles.containerInputs}>
          <Grid
            container
            spacing={1}
            style={{ width: "100%", margin: 0, padding: 0 }}
          >
            <Grid item xl={5} lg={5} md={5} sm={5}>
              <InputForm
                type="text"
                name="adverseParty"
                placeholder="Digite as parte adversa"
                label={"Parte Adversa"}
                value={adverseParty}
                error={adversePartyError}
                onChange={handleInputAdverseParty}
                role={adversePartyRole}
                isDisabled={
                  auth.user.role == USER_ROLES.ADMIN ||
                  auth.user.role == USER_ROLES.COLLABORATOR
                    ? false
                    : true
                }
              />
            </Grid>
            <Grid item xl={3} lg={3} md={3} sm={3}>
              <InputForm
                type="text"
                name="courtCaseNumber"
                placeholder="Digite o número dos autos"
                label={"Número dos Autos"}
                value={courtCaseNumber}
                error={courtCaseNumberError}
                onChange={handleInputCourtCaseNumber}
                role={courtCaseNumberRole}
                isDisabled={
                  auth.user.role == USER_ROLES.ADMIN ||
                  auth.user.role == USER_ROLES.COLLABORATOR
                    ? false
                    : true
                }
              />
            </Grid>
            <Grid item xl={4} lg={4} md={4} sm={4}>
              <InputForm
                type="text"
                name="action"
                placeholder="Ação"
                label={"Ação"}
                required={true}
                value={action}
                onChange={handleInputAction}
                error={actionError}
                role={actionRole}
                isSelect={true}
                options={actionsList}
                isDisabled={
                  auth.user.role == USER_ROLES.ADMIN ||
                  auth.user.role == USER_ROLES.COLLABORATOR
                    ? false
                    : true
                }
              />
            </Grid>
          </Grid>
        </div>
        <div className={styles.containerInputs}>
          <Grid
            container
            spacing={1}
            style={{ width: "100%", margin: 0, padding: 0 }}
          >
            <Grid item xl={4} lg={4} md={4} sm={4}>
              <InputForm
                type="text"
                name="value"
                placeholder="Digite o valor"
                label={"Valor do Processo"}
                value={value}
                error={valueError}
                onChange={handleInputValue}
                role={valueRole}
                isDisabled={
                  auth.user.role == USER_ROLES.ADMIN ||
                  auth.user.role == USER_ROLES.COLLABORATOR
                    ? false
                    : true
                }
              />
            </Grid>
            <Grid item xl={4} lg={4} md={4} sm={4}>
              <InputForm
                type="date"
                name="distributionDate"
                placeholder="Digite a data de distribuição"
                label={"Data de distribuição"}
                value={distributionDate}
                error={distributionDateError}
                onChange={handleInputDistributionDate}
                role={distributionDateRole}
                isDisabled={
                  auth.user.role == USER_ROLES.ADMIN ||
                  auth.user.role == USER_ROLES.COLLABORATOR
                    ? false
                    : true
                }
              />
            </Grid>
            <Grid item xl={4} lg={4} md={4} sm={4}>
              <InputForm
                type="date"
                name="limitDate"
                placeholder="Digite a data limite"
                label={"Data limite *"}
                value={limitDate}
                error={limitDateError}
                onChange={handleInputLimitDate}
                role={limitDateRole}
                isDisabled={
                  auth.user.role == USER_ROLES.ADMIN ||
                  auth.user.role == USER_ROLES.COLLABORATOR
                    ? false
                    : true
                }
              />
            </Grid>
          </Grid>
        </div>
        <div className={styles.containerInputs}>
          <Grid
            container
            spacing={1}
            style={{ width: "100%", margin: 0, padding: 0 }}
          >
            <Grid item xl={4} lg={4} md={4} sm={6}>
              <InputForm
                type="number"
                name="billingAlert"
                placeholder="Digite a frequêcia dos alertas"
                label={"Alertas de Cobrança (em dias) *"}
                value={billingAlert}
                error={billingAlertError}
                onChange={handleInputBillingAlert}
                role={billingAlertRole}
                isDisabled={
                  auth.user.role == USER_ROLES.ADMIN ||
                  auth.user.role == USER_ROLES.COLLABORATOR
                    ? false
                    : true
                }
              />
            </Grid>
            <Grid item xl={4} lg={4} md={4} sm={6}>
              <InputForm
                name="status"
                placeholder="Selecione o Status"
                value={lawsuitStatus}
                error={lawsuitStatusError}
                onChange={(e) => setLawsuitStatus(e)}
                role={lawsuitStatusRole}
                label={"Status"}
                isSelect
                options={optionsStatus}
                isDisabled={
                  auth.user.role == USER_ROLES.ADMIN ||
                  auth.user.role == USER_ROLES.COLLABORATOR
                    ? false
                    : true
                }
              />
            </Grid>
          </Grid>
        </div>
        <div
          className="xv-lawsuit-form-actions"
          style={{
            display:
              auth.user.role !== USER_ROLES.ADMIN &&
              auth.user.role !== USER_ROLES.COLLABORATOR
                ? "none"
                : "flex",
            justifyContent: "flex-end",
            marginTop: "1rem",
            padding: 0,
          }}
        >
          <FormActions
            module={"processo"}
            formIsValid={formIsValid()}
            onCleanForm={onCleanForm}
            onSubmit={submit}
            hideCancel={true}
            messagem
          />
          <Button
            className="xv-form-action xv-form-action--document-reminder"
            onClick={handleSendDocumentEmail}
            variant="cancel"
            color={globalColors.primaryColor2}
            type="button"
          >
            Enviar cobrança de documentos
          </Button>
        </div>
      </form>
      <div
        className="xv-themed-surface"
        style={{
          marginTop: "1rem",
          padding: 0,
          backgroundColor: "#fff",
        }}
      >
        {user && (
          <Container
            maxWidth="100%"
            style={{
              padding: 0,
              margin: 0,
            }}
          >
            <UserDocumentsDataTable
              refetchLogs={refetch}
              userId={user.id}
              handleGetParent={fetchLawsuitInfo}
            />
          </Container>
        )}
      </div>
      <div
        className={`${styles.form} xv-themed-surface`}
        style={{
          marginTop: "1rem",
          minHeight: "200px",
        }}
      >
        {actionId && (
          <Container
            maxWidth="100%"
            style={{
              padding: 0,
              margin: 0,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Container
              maxWidth="100%"
              style={{
                padding: 0,
                marginBottom: "20px",
              }}
            >
              <LabelWithBackLine
                button={
                  auth.user.role == USER_ROLES.ADMIN ||
                  auth?.user.role == USER_ROLES.COLLABORATOR
                    ? true
                    : false
                }
                handleOpen={setOpenAddDocumentCategory}
              >
                {`Documentos do Processo
                  ${
                    action?.label
                      ? action.label.length > 40 && window.innerWidth <= 1370
                        ? " - " + action.label.substring(0, 40) + "..."
                        : " - " + action.label
                      : null
                  }`}
              </LabelWithBackLine>
            </Container>
            <LawsuitDocumentTable
              lawsuitId={id}
              setReload={setReload}
              reload={reload}
            />
          </Container>
        )}
      </div>
      <div
        className={`${styles.form} xv-themed-surface`}
        style={{
          marginTop: "1rem",
          minHeight: "200px",
        }}
      >
        {actionId && (
          <Container
            maxWidth="100%"
            style={{
              padding: 0,
              margin: 0,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Container
              maxWidth="100%"
              style={{
                padding: 0,
                marginBottom: "20px",
              }}
            >
              <LabelWithBackLine>{`Logs do processo`}</LabelWithBackLine>
            </Container>

            <LogsView
              item={item}
              isLoading={isLoading}
              handlePageChange={handlePageChange}
            />
          </Container>
        )}
      </div>
      <div
        className={`${styles.form} xv-themed-surface`}
        style={{
          marginTop: "1rem",
          minHeight: "200px",
          display: hasPublication ? "flex" : "none",
        }}
      >
        <Container
          maxWidth="100%"
          style={{
            padding: 0,
            margin: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Container
            maxWidth="100%"
            style={{
              padding: 0,
              marginBottom: "20px",
            }}
          >
            <LabelWithBackLine>Publicações do Processo</LabelWithBackLine>
          </Container>
          {courtCaseNumber && (
            <PublicationsTable
              setPublication={setPublication}
              togglePublicationModal={togglePublicationModal}
              lawsuitId={courtCaseNumber.replace(/\D/g, "")}
              setHasPublication={setHasPublication}
            />
          )}
        </Container>
      </div>
    </div>
  );
};
export default LawsuitFormEdit;
